export interface Sizes {
  desktop: string;
  notebook: string;
  tablet: string;
  mobile: string;
}

export const BlockSize = {
  Full: "full",
  Half: "half",
} as const;

interface ColumnCounts {
  mobile: number;
  tablet: number;
  notebook: number;
  desktop: number;
}

/**
 * Returns full-width size hints for the last block in a content area row.
 * A block is considered "lonely" when it starts at column position 1 of its
 * row (desktop-driven tracking) AND it is the last item in the list.
 */
export function getContextSize(
  itemIndex: number,
  columnPosition: number,
  totalItems: number,
  columns: ColumnCounts,
): Sizes {
  const isLastItem = itemIndex === totalItems - 1;
  return {
    mobile: isLastItem && columnPosition % columns.mobile === 1 ? BlockSize.Full : "",
    tablet: isLastItem && columnPosition % columns.tablet === 1 ? BlockSize.Full : "",
    notebook: isLastItem && columnPosition % columns.notebook === 1 ? BlockSize.Full : "",
    desktop: isLastItem && columnPosition % columns.desktop === 1 ? BlockSize.Full : "",
  };
}
